import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from 'material-ui/Typography';
import { formatProfile } from '../../../../../utils/utils';

const styles = () => ({
  name: {
    color: 'inherit',
    fontSize: '15px',
    fontWeight: 'bold',
  },

  introduce: {
    fontSize: '11px',
    color: 'inherit',
    marginTop: '5px',
  },

  introduce2: {
    fontSize: '11px',
    color: 'inherit',
    marginTop: '5px',
  }
});

class KeymanProfile extends React.Component {
  render () {
    const { classes } = this.props;
    return (
      <div>
        <Typography className={classes.name}>
          {`${this.props.item.company_name} ${this.props.item.name} 様`}
        </Typography>
        <Typography variant="body2" className={classes.introduce2}>
          {formatProfile(this.props.item)}
        </Typography>
        {this.props.children}
      </div>
    );
  }
}

KeymanProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  children: PropTypes.node,
}

PropTypes.defaultValue = {
}

export default withStyles(styles)(KeymanProfile);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/parts/KeymanProfile.jsx